export default function getSubgroup(order) {
  return {
    description:      'MISCELLANEOUS',
    displayBarcodes:  order.displayBarcodes,
    displayTime:      order.displayTime,
    editionTitle:     order.printedName,
    fullCode:         'WAR-MIS',
    groupDescription: 'WARRANTY REPAIRS',
    tradeName:        order.getTitle(),
  }
}